import { render, staticRenderFns } from "./MovementGroups.vue?vue&type=template&id=7ac4b9ef&scoped=true&"
import script from "./MovementGroups.vue?vue&type=script&lang=js&"
export * from "./MovementGroups.vue?vue&type=script&lang=js&"
import style0 from "./MovementGroups.vue?vue&type=style&index=0&id=7ac4b9ef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ac4b9ef",
  null
  
)

export default component.exports